import { PackageLine } from '@r1-frontend/api-domru/api-tariffs/v1/web/lines';

import { TPackageLine, TPackageLineContent } from '~/src/features/index/MultiPackageList/context/initialState';
import { getBackgroundById } from '~/src/features/index/MultiPackageList/transformApiTariffAnswerToMultiPackage/getBackgroundById';

const equipmentIconsMap = {
    'роутер': '/static/images/multiPackageCard/router.png',
    'router': '/static/images/multiPackageCard/router.png',
    'тв-приставка': '/static/images/multiPackageCard/tv.png',
    'tv': '/static/images/multiPackageCard/tv.png',
};

const transformPackageLineToMultiPackage = (packageLine: PackageLine): TPackageLine => {
    const content = Object.values(packageLine.packages).reduce<Record<number, TPackageLineContent>>((cnt, pkg) => {
        cnt[pkg.id] = {
            id: pkg.id,
            packageName: pkg.packageName || `mocked description ${pkg.id}`,
            isMono: pkg.isMono,
            isForCottage: pkg.isForCottage,
            speed: pkg.speed,
            price: pkg.price,
            // Sorting has been implemented to ensure that the subscriptions container stretches to the full width of its parent container.
            items: pkg.items
                .map(item => {
                    if (item.type === 'equipment') {
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore adding stub images for an equipment
                        item.images = item.description.split(', ').map(name => equipmentIconsMap[name.toLowerCase()]);
                    }

                    return item;
                })
                .sort(item => item.type === 'subscription' ? -1 : 0),
        };

        return cnt;
    }, {});

    return {
        id: packageLine.id,
        background: {
            image: getBackgroundById(packageLine.id),
            color: undefined,
        },
        name: packageLine.name,
        content,
        currentPackageId: 0, // stub for the TS type, it's processing inside the getFilteredLines
    };
};

export default transformPackageLineToMultiPackage;
